import React, { Component } from "react";


export default class Gallery2018 extends Component {

  constructor(props){
    super(props);
    this.state ={

    };
  }

  getGalleryImageElements(){
    var galleryImageElements = [];
    for(var i = 1; i < 17 ; i+=2){
      galleryImageElements.push(
            <div className="row cols-md-space cols-sm-space cols-xs-space">
                <div className="col-lg-6">
                    <div className="card z-depth-2-top">
                        <div className="card-image">
                            <div className="view view-first">
                                <a href="/">
                                    <img src={"/images/2018/" + i +".JPG"} />
                                </a>
                            </div>
                        </div>


                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="card z-depth-2-top">
                        <div className="card-image">
                            <div className="view view-first">
                                <a href="#">
                                    <img src={"/images/2018/" + (i+1) +".JPG"} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      );
    }
    return galleryImageElements;
  }



  render() {
      return (
        <div className="container-fluid">
            {this.getGalleryImageElements()}
        </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Gallery2018.js